import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";
import LocalStorageService from "../../common/services/LocalStorageService";

// Server basket line -> the cart item shape the UI already renders
// (same shape addToCard builds for guests, details trimmed to what's used).
export const mapServerBasketItems = (data) =>
  (data?.items || []).map((line) => ({
    menu_item: line?.menu_item,
    details: {
      id: line?.menu_item,
      name: line?.menu_item_name,
      picture_url: line?.picture_url,
    },
    quantity: line?.quantity,
    variant: line?.variant,
    key: line?.variant?.id,
    id: line?.menu_item,
    is_available: line?.is_available,
    available_count: line?.available_count,
  }));

export const getBasket = createAsyncThunk(
  "basket/get",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL_V2}/basket/`);
      return mapServerBasketItems(data);
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const setBasketItem = createAsyncThunk(
  "basket/set_item",
  async ({ variant_id, quantity }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(`${config.API_URL_V2}/basket/items/`, {
        variant_id,
        quantity,
      });
      return mapServerBasketItems(data);
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const removeBasketItem = createAsyncThunk(
  "basket/remove_item",
  async (variantId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL_V2}/basket/items/${variantId}/`
      );
      return mapServerBasketItems(data);
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

export const mergeBasket = createAsyncThunk(
  "basket/merge",
  async (localItems, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(`${config.API_URL_V2}/basket/merge/`, {
        items: (localItems || []).map((el) => ({
          variant_id: el?.variant?.id,
          quantity: el?.quantity,
        })),
      });
      // The guest cart now lives on the server — local copy is done.
      LocalStorageService.remove("items");
      return mapServerBasketItems(data);
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
